<template>
  <div>
    <b-loading :active.sync="isLoadingPage"></b-loading>
    <div class="level">
      <p class="is-size-5 has-text-weight-semibold">
        {{ $t("form.formHeader") }}
      </p>
      <b-dropdown ref="dropdown" position="is-bottom-left">
        <button class="button btn-Filter" slot="trigger">
          <span class="icon is-small">
            <i class="fa fa-filter"></i>
          </span>
          <span>{{ $t("form.filterHeader") }}</span>
        </button>
        <b-dropdown-item custom paddingless>
          <div class="modal-card mx-not modal-search">
            <section class="modal-card-body contentSearch">
              <div class="headerFilter">
                <span class="icon is-small is-size-5">
                  <i class="fa fa-filter"></i>
                </span>
                <span
                  class="is-padding-sm-x is-size-5 has-text-weight-normal"
                  >{{ $t("form.filterHeader") }}</span
                >
              </div>
              <b-field grouped>
                <b-input
                  class="is-medium"
                  type="search"
                  icon-pack="fas"
                  icon="search"
                  placeholder="Name Lastname"
                  v-model="searchNameLastName"
                  expanded
                ></b-input>
              </b-field>

              <b-field grouped>
                <b-input
                  class="is-medium"
                  type="search"
                  icon-pack="fas"
                  icon="search"
                  placeholder="OrganizeName"
                  v-model="searchOrganizeName"
                  expanded
                ></b-input>
              </b-field>

              <b-field grouped>
                <div class="control is-expanded level">
                  <div class="search-btn">
                    <button class="button btnSearch" @click="filter()">
                      {{ $t("message.btnSearch") }}
                    </button>
                  </div>
                  <div class="reset-btn">
                    <button @click="resetFilter()" class="button btnReset th">
                      {{ $t("form.btnReset") }}
                    </button>
                  </div>
                </div>
              </b-field>
            </section>
          </div>
        </b-dropdown-item>
      </b-dropdown>
    </div>
    <div
      v-if="adminFormsFilter.length === 0"
      class="columns is-vcentered m-h-auto"
      id="noData"
    >
      <div
        class="column has-text-centered is-flex is-align-center is-justify-center"
      >
        <p class="has-text-grey is-size-4 th is-padding-x-s is-margin-top-s">
          ***
        </p>
        <p class="has-text-grey is-size-6 th is-padding-x has-text-centered">
          {{ $t("form.notFoundAdmin") }}
        </p>
        <p class="has-text-grey is-size-4 th is-padding-x-s is-margin-top-s">
          ***
        </p>
      </div>
    </div>
    <div v-else class="columns m-h-auto is-flex-wrap is-align-center">
      <div
        v-for="(item, index) in adminFormsFilter"
        :key="index"
        class="column is-6"
      >
        <div
          :title="item.form.length > 0 ? getFormName(item.form[0].id) : null"
          class="has-background-white box-border pd-20"
        >
          <a
            @click="openModalForm(item, 'edit')"
            v-if="item.form.length !== 0"
            class="is-size-7 is-flex is-align-center is-justify-end th edit-form"
          >
            <b-icon
              pack="fas"
              icon="pencil-alt"
              size="is-small"
              class="mg-r-5"
            ></b-icon
            >{{ $t("form.changeFormType") }}
          </a>
          <div v-else class="pd-10"></div>
          <p class="pd-5">
            <span class="has-text-weight-semibold">
              {{ $t("form.adminName") }}:</span
            >
            <span class="th pd-l-5">{{ item.name }} {{ item.surname }}</span>
          </p>
          <p class="pd-5">
            <span class="has-text-weight-semibold">
              {{ $t("form.organizeName") }}:</span
            >
            <span class="th pd-l-5">{{ item.organizeName }}</span>
          </p>
          <div class="has-text-centered">
            <a
              v-if="item.form.length === 0"
              @click="openModalForm(item, 'add')"
              class="button btn-form th"
              >{{ $t("form.pleaseSelectForm") }}</a
            >
            <a
              v-else
              @click="openModalForm(item, 'edit')"
              class="button btn-form-outlined th"
              >{{ getFormName(item.form[0].id) | snippetMobile
              }}<span v-if="item.form.length > 1"
                >,.. {{ $t("form.viewAll") }}</span
              ></a
            >
          </div>
        </div>
      </div>
    </div>

    <b-modal
      :active.sync="isForm"
      :width="2000"
      @close="closeModalIsForm"
      class="modal-max"
    >
      <div class="card">
        <div class="card-content">
          <div class="content">
            <div class="columns m-h-auto is-vcentered border-bottom is-">
              <div class="column is-4 th has-text-weight-normal is-size-5">
                <p v-if="isFormModalType === 'add'">
                  {{ $t("form.pleaseSelectForm") }}
                </p>
                <p v-if="isFormModalType === 'edit'">
                  {{ $t("form.pleaseChangeFormOrAdd") }}
                </p>
              </div>

              <div class="column is-4">
                <p v-if="formsUserData !== null">
                  <span class="has-text-weight-semibold"
                    >{{ $t("form.adminName") }}:</span
                  >
                  <span class="th pd-l-5"
                    >{{ formsUserData.name }}
                    {{ formsUserData.surname | snippetMiniSmall }}</span
                  >
                </p>
              </div>
              <div class="column">
                <p v-if="formsUserData !== null">
                  <span class="has-text-weight-semibold"
                    >{{ $t("form.organizeName") }}:</span
                  >
                  <span class="th pd-l-5">{{
                    formsUserData.organizeName | snippetProfileEdit
                  }}</span>
                </p>
              </div>
            </div>
            <div class="columns m-h-auto">
              <div class="column is-4 box-border mg-10 is-paddingless">
                <div class="has-text-centered border-bottom pd-y-15">
                  <p
                    v-if="formsComponent.length !== 0"
                    class="is-size-6 th has-text-weight-normal"
                  >
                    {{ $t("form.formTypeAll") }} ({{
                      formsComponent.form.length
                    }}
                    {{ $t("form.typeUnit") }})
                  </p>
                </div>
                <div class="column pd-x-20">
                  <b-input
                    placeholder="Search..."
                    type="search"
                    icon-pack="fas"
                    v-model="searchFormName"
                    icon="search"
                  >
                  </b-input>
                </div>
                <div class="scroll pd-x-10">
                  <div
                    class="column"
                    v-for="item in filterFormName"
                    :key="item._id"
                  >
                    <div class="field is-flex">
                      <b-checkbox
                        type="is-dark"
                        v-model="checkForm"
                        :disabled="getDisabledForm(item._id)"
                        :native-value="{ id: item._id, type: item.type }"
                      ></b-checkbox>
                      <a
                        class="is-size-6 th"
                        :title="item.name"
                        :class="
                          item._id !== selectForm
                            ? 'has-text-black'
                            : 'has-text-secondary'
                        "
                        @click="setSelectForm(item._id)"
                        >{{ item.name | snippetProfileEdit }}</a
                      >
                      <b-dropdown v-if="getDisabledForm(item._id)">
                        <p
                          class="tag is-success mg-l-5"
                          id="changForm"
                          slot="trigger"
                        >
                          {{ $t("form.change") }}
                        </p>
                        <div v-for="itemDp in filterFormName" :key="itemDp._id">
                          <b-dropdown-item
                            @click="confirmChangForm(itemDp, item)"
                            v-if="!getDisabledForm(itemDp._id)"
                            >{{ itemDp.name | snippetMobile }}</b-dropdown-item
                          >
                        </div>
                      </b-dropdown>
                    </div>
                  </div>
                </div>
              </div>
              <div class="column box-border mg-10 is-paddingless">
                <div v-if="selectForm !== null">
                  <div class="has-text-centered border-bottom pd-y-15">
                    <p class="is-size-6 has-text-weight-normal th">
                      {{ getFormName(selectForm) }}
                    </p>
                  </div>
                  <div>
                    <FormMange
                      v-if="renderComponent === true"
                      :tab="false"
                      :formProps="getFormToId(selectForm)"
                      :startupIdProps="null"
                      :batchData="{}"
                      :demo="true"
                      :isLockForm="null"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="columns m-h-auto">
              <div class="column is-offset-4 has-text-centered is-paddingless">
                <a @click="addFormToadmin()" class="button btn-form-add th">{{
                  $t("form.btnOK")
                }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { HTTP, HTTPDynamic } from "../axios";
import FormMange from "./form/FormMange";
export default {
  components: {
    FormMange,
  },
  data() {
    return {
      isForm: false,
      checkForm: [],
      checkFormCon: [],
      formsUserData: null,
      formsComponent: [],
      adminForms: [],
      adminFormsFilter: [],
      searchFormName: "",
      isFormModalType: null,
      searchNameLastName: null,
      searchOrganizeName: null,
      isLoadingPage: true,
      stepIndex: 0,
      selectForm: null,
      inputValue: {},
      renderComponent: false,
      inputValidate: {},
      checkModelValue: {},
      checkVarDes: {},
      dataInputKpi: {},
      dataKpi: {},
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    filterFormName() {
      if (this.searchFormName !== "") {
        return this.formsComponent.form.filter(
          (item) =>
            item.name
              .toLowerCase()
              .indexOf(this.searchFormName.toLowerCase()) >= 0
        );
      } else {
        return this.formsComponent.form;
      }
    },
    getRule() {
      return this.$store.getters.getRule;
    },
  },
  created() {
    this.fethAdminForm(false);
    this.fethFormAllAdmin();
  },
  mounted() {
    this.isLoadingPage = false;
  },
  methods: {
    getFormToId(id) {
      if (id !== null && typeof id !== "undefined") {
        let forms = this.formsComponent.form.filter((item) => item._id === id);
        if (forms.length > 0) {
          return forms[0];
        } else {
          return [];
        }
      } else {
        return {};
      }
    },
    async fethFormAllAdmin() {
      let data = {
        formTypeId: "5c4034f19ccfe7668c06884d",
        userLevel: 99,
      };
      HTTPDynamic.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTPDynamic.post(`special/admin/get/form`, data)
        .then((res) => {
          //  console.log("special/admin/get/form", res);
          if (res.data.success) {
            this.formsComponent = {
              form: [],
            };
            if (res.data.obj.form.length === 0) {
              this.isLoadingPage = false;
            }

            for (let index = 0; index < res.data.obj.form.length; index++) {
              setTimeout(() => {
                if (res.data.obj.form[index].type !== "component") {
                  this.fetchTmp(res.data.obj.form[index]._id);
                } else {
                  this.fethFormComponent(res.data.obj.form[index]._id);
                }
              }, 100 * index);
            }
          } else {
            this.formsComponent = [];
          }
        })
        .catch((e) => {
          console.log("special/admin/get/form/error", e);
        });
    },
    fethAdminForm(update) {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.get(`get/all/admin`)
        .then((res) => {
          //console.log("get/all/admin", res.data.obj.users);
          if (res.data.success) {
            this.adminForms = res.data.obj.users;
            this.adminFormsFilter = res.data.obj.users;
            if (update) {
              this.checkFormCon = [];
              this.checkForm = [];
              let check = res.data.obj.users.filter(
                (item) => item._id === this.formsUserData._id
              );
              check[0].form.map((item) => {
                this.checkFormCon.push(item);
                this.checkForm.push(item);
              });
              // console.log("lskdlsakdlsakdsad",this.formsUserData)
              // console.log("lskdlsakdlsakdsad",check)
              // console.log("lskdlsakdlsakdsad",this.checkForm)
            }
          } else {
            this.adminForms = [];
          }
        })
        .catch((e) => {
          console.log("get/all/admin/error", e);
        });
    },
    async fethFormComponent(value) {
      let data = {
        components: [value],
      };
      // console.log("data",data)
      HTTPDynamic.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      await HTTPDynamic.post(`get/component/by/id`, data)
        .then((res) => {
          //  console.log("get/component/by/id",res)
          if (res.data.success) {
            let obj = {
              components: res.data.obj.form[0].components,
              name: res.data.obj.form[0].name,
              _id: res.data.obj.form[0]._id,
              type: "component",
            };
            this.formsComponent.form.push(obj);
          }
          this.isLoadingPage = false;
          this.renderComponent = true;
        })
        .catch((e) => {
          this.isLoadingPage = false;
          this.renderComponent = true;
          console.log("get/component/by/id/error", e);
        });
    },
    async fetchTmp(id) {
      let data = {
        templateId: id,
      };
      HTTPDynamic.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      await HTTPDynamic.post(`get/template/by/id`, data)
        .then((res) => {
          //  console.log("get/template/by/id", res);
          if (res.data.success) {
            this.formsComponent.form.push(res.data.obj);
          }
          this.isLoadingPage = false;
          this.renderComponent = true;
        })
        .catch((e) => {
          this.isLoadingPage = false;
          this.renderComponent = true;
          console.log("get/template/by/id/error", e);
        });
    },
    async getComponent(id, form) {
      let arr = [];
      arr[0] = id;

      let data = {
        components: arr,
      };

      HTTPDynamic.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      await HTTPDynamic.post(`get/component/by/id`, data)
        .then((res) => {
          // console.log("get/component/by/id", res.data.obj.form[0]);
          if (res.data.success) {
            if (typeof res.data.obj.form[0] !== "undefined") {
              res.data.obj.form[0].components.map((item, index) => {
                form.push(item);
              });
            }
          } else {
            this.dataFormInput = [];
          }
        })
        .catch((e) => {
          console.log("get/component/by/id/error", e);
        });
    },
    addFormToadmin() {
      this.isLoadingPage = true;
      let data = {
        componentId: this.checkForm,
        adminId: this.formsUserData._id,
      };
      //    console.log("push/form/to/admin/res", data);
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`push/form/to/admin`, data)
        .then((res) => {
          // console.log("push/form/to/admin", res);
          if (res.data.success) {
            this.fethAdminForm(false);
            this.isForm = false;
            this.$store.commit("setModalActive", false);
          } else {
            this.$buefy.dialog.alert(
              '<p class="has-text-centered is-size-5">ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง</p>'
            );
          }
          this.isLoadingPage = false;
        })
        .catch((e) => {
          console.log("push/form/to/admin/error", e);
          this.$buefy.dialog.alert(
            '<p class="has-text-centered is-size-5">เครือขายไม่เสถียร กรุณาลองใหม่</p>'
          );
          this.isLoadingPage = false;
        });
    },
    confirmChangForm(data, dataOld) {
      this.$buefy.dialog.confirm({
        message: `<h3 class="title is-4 has-text-centered">ท่านต้องการเปลี่ยน Form</h3><p class="has-text-centered"><span class="has-text-weight-normal">${dataOld.name}</span> เป็น <span class="has-text-weight-normal">${data.name}</span></p>`,
        onConfirm: () => this.changFormToadmin(data, dataOld._id),
      });
    },
    changFormToadmin(newData, oldId) {
      this.isLoadingPage = true;
      let data = {
        adminId: this.formsUserData._id,
        oldForm: oldId,
        newForm: { id: newData._id, type: newData.type },
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`change/form`, data)
        .then((res) => {
          // console.log("change/form", res);
          if (res.data.success) {
            this.fethAdminForm(true);
            this.fethFormComponent();
          } else {
            this.$buefy.dialog.alert(
              '<p class="has-text-centered is-size-5">ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง</p>'
            );
          }
          this.isLoadingPage = false;
        })
        .catch((e) => {
          console.log("push/form/to/admin/error", e);
          this.$buefy.dialog.alert(
            '<p class="has-text-centered is-size-5">เครือขายไม่เสถียร กรุณาลองใหม่</p>'
          );
          this.isLoadingPage = false;
        });
    },
    getFormName(id) {
      if (this.formsComponent.length !== 0) {
        let res = this.formsComponent.form.filter((item) => item._id === id);
        if (typeof res[0] !== "undefined") {
          return res[0].name;
        } else {
          return "ไม่มีรูปแบบฟอร์มนี้";
        }
      } else {
        return "ไม่มีรูปแบบฟอร์มนี้";
      }
    },
    openModalForm(item, type) {
      this.checkForm = [];
      this.selectForm = null;
      this.isForm = true;
      this.$store.commit("setModalActive", true);

      if (type === "edit") {
        this.checkForm = item.form;
        this.checkFormCon = item.form;
        this.selectForm = item.form[0].id;
      }

      this.renderComponent = false;
      setTimeout(() => {
        this.renderComponent = true;
      }, 1000);

      this.formsUserData = item;
      this.isFormModalType = type;
    },
    getDisabledForm(id) {
      let check = this.checkFormCon.filter((item) => item.id === id);
      if (check.length === 0) {
        return false;
      } else {
        return true;
      }
    },
    filter() {
      if (this.searchNameLastName == null && this.searchOrganizeName == null) {
        this.adminFormsFilter = this.adminForms;
      } else if (
        this.searchNameLastName != null &&
        this.searchOrganizeName == null
      ) {
        this.adminFormsFilter = this.adminForms.filter(
          (item) =>
            item.name
              .toLowerCase()
              .indexOf(this.searchNameLastName.toLowerCase()) >= 0 ||
            item.surname
              .toLowerCase()
              .indexOf(this.searchNameLastName.toLowerCase()) >= 0
        );
      } else if (
        this.searchNameLastName != null &&
        this.searchOrganizeName != null
      ) {
        this.adminFormsFilter = this.adminForms.filter(
          (item) =>
            (item.name
              .toLowerCase()
              .indexOf(this.searchNameLastName.toLowerCase()) >= 0 ||
              item.surname
                .toLowerCase()
                .indexOf(this.searchNameLastName.toLowerCase()) >= 0) &&
            item.organizeName
              .toLowerCase()
              .indexOf(this.searchOrganizeName.toLowerCase()) >= 0
        );
      } else if (
        this.searchNameLastName == null &&
        this.searchOrganizeName != null
      ) {
        this.adminFormsFilter = this.adminForms.filter(
          (item) =>
            item.organizeName
              .toLowerCase()
              .indexOf(this.searchOrganizeName.toLowerCase()) >= 0
        );
      } else {
        this.adminFormsFilter = this.adminForms;
      }

      if (typeof this.$refs.dropdown !== "undefined") {
        this.$refs.dropdown.isActive = false;
      }
    },
    resetFilter() {
      this.searchNameLastName = null;
      this.searchOrganizeName = null;
      this.adminFormsFilter = this.adminForms;
    },
    setSelectForm(id) {
      this.stepIndex = 0;
      this.selectForm = id;
      this.renderComponent = false;
      setTimeout(() => {
        this.renderComponent = true;
      }, 1000);

      this.inputValidate = {};
    },
    changStep(index) {
      this.renderComponent = false;
      setTimeout(() => {
        this.renderComponent = true;
      }, 1000);
      this.stepIndex = index;
      this.inputValidate = {};
    },
    closeModalIsForm() {
      this.$store.commit("setModalActive", false);
    },
    async setValidInput(components) {
      await components.map(async (component) => {
        await component.componentData.map((item) => {
          this.inputValidate[item.name] = {
            name: item.name,
            validation: item.validation,
            type: item.type,
            valid: false,
          };
        });

        if (component.children.length > 0) {
          await this.setValidInput(component.children);
        } else {
          this.renderComponent = true;
        }
      });
    },
    async setVarinput(components) {
      let value = [];
      if (
        typeof this.dataFormInput !== "undefined" &&
        Object.values(this.dataFormInput).length !== 0
      ) {
        value = this.dataFormInput.filter(
          (item) => item.step === this.stepIndex
        );
      }

      await components.map(async (component) => {
        await component.componentData.map((item) => {
          if (item.type === "checkbox") {
            this.inputValue[item.name] = [];
            this.checkModelValue[item.name] = [];
            for (let index = 0; index < item.display.value.length; index++) {
              if (
                typeof item.display.value[index].userValue !== "undefined" &&
                item.display.value[index].userValue === true
              ) {
                this.checkVarDes[item.name + index] = {
                  index: index,
                  des: null,
                };
              }
            }
          } else if (item.type === "date") {
            this.inputValue[item.name] = null;
          } else if (item.type === "file") {
            this.inputValue[item.name] = [];
          } else if (item.type === "radio") {
            this.inputValue[item.name] = { data: null, des: null };
          } else {
            this.inputValue[item.name] = null;
            this.dataInputKpi[item.name] = {
              type: item.type,
              input: "",
              lastUpdate: null,
            };
          }

          if (item.type === "radio") {
            for (let index = 0; index < item.display.value.length; index++) {
              if (
                typeof item.display.value[index].userValue !== "undefined" &&
                item.display.value[index].userValue === true
              ) {
                this.inputValidate[item.name + "UserValue" + index] = {
                  name: item.name,
                  validation: { errorMsg: "กรุณากรอกข้อความ", required: true },
                  type: "radioDes",
                  valid: false,
                };
              }
            }
          }

          if (item.type === "checkbox") {
            for (let index = 0; index < item.display.value.length; index++) {
              if (
                typeof item.display.value[index].userValue !== "undefined" &&
                item.display.value[index].userValue === true
              ) {
                this.inputValidate[item.name + "UserValue" + index] = {
                  name: item.name,
                  validation: { errorMsg: "กรุณากรอกข้อความ", required: true },
                  type: "checkBoxDes",
                  valid: false,
                };
              }
            }
          }

          this.inputValidate[item.name] = {
            name: item.name,
            validation: item.validation,
            type: item.type,
            valid: false,
          };
        });

        if (component.children.length > 0) {
          await this.setVarinput(component.children);
        } else {
          setTimeout(() => {
            this.renderComponent = true;
          }, 500);
        }
      });
    },
  },
};
</script>
<style scoped>
.card {
  color: #0a0a0a;
}
.border-bottom {
  border-bottom: 1px solid #d8d8d8;
}
.scroll {
  overflow-y: scroll;
  height: 550px;
}
.scroll::-webkit-scrollbar {
  display: unset !important;
  -webkit-appearance: none;
  width: 7px;
}
.scroll::-webkit-scrollbar-thumb {
  border-radius: 4px;
  -webkit-box-shadow: 0 0 1px rgba(216, 216, 216, 100%);
  background-color: rgba(216, 216, 216, 100%);
}
.scroll::-webkit-scrollbar-track {
  display: none;
}
.btn-form {
  min-width: 250px;
  min-height: 45px;
  background-color: #6d8df3;
  color: #ffffff;
  margin: 5px;
}
.btn-form-outlined {
  min-width: 250px;
  min-height: 45px;
  border: 1px solid #6d8df3;
  color: #6d8df3;
  margin: 5px;
}
.btn-form-add {
  min-width: 130px;
  min-height: 40px;
  border: 1px solid #6d8df3;
  color: #6d8df3;
  margin: 5px;
}
.edit-form {
  color: #707070;
}
.edit-form:hover {
  color: #6d8df3;
}
#noData {
  padding: 150px;
}
footer {
  opacity: 1 !important;
}
#changForm {
  background-color: #6d8df3;
  color: white;
  cursor: pointer;
}
#changForm:hover {
  color: black;
}
</style>
